import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import Actions from "../../Redux/Actions";
import { WithDrawerConsumer } from "../../Contexts/DrawerContext/withDrawerConsumer";
import UserFieldEditorFooter from "../UserFieldEditorFooter/UserFieldEditorFooter";
import { AlliedForcesApplicationSteps } from "../../Redux/Reducers/AlliedForcesApplication/AlliedForcesApplicationMetadata";
import constants from "../../Constants";
import { allFormsFilled } from "../../Redux/Utils/reducerUtils";
import ApplicationConfirmationModal from "./AlliedForcesApplicationConfirmationModal"; // Adjust if you have a custom confirmation modal

const AlliedForcesApplicationFooter = (props) => {
  const getNextPage = () => {
    const pageTitle = queryString.parse(props.history.location.search).title;
    const currentPageIndex = AlliedForcesApplicationSteps.findIndex(
      (elem) => elem.stepId === pageTitle
    );

    if (pageTitle === "personal_info-address") {
      if (props.application && props.application.userWillReLocate) {
        return AlliedForcesApplicationSteps[currentPageIndex + 1].stepId;
      }
      return AlliedForcesApplicationSteps[currentPageIndex + 2].stepId;
    }
    return AlliedForcesApplicationSteps[currentPageIndex + 1].stepId;
  };

  const getPreviousPage = () => {
    const pageTitle = queryString.parse(props.history.location.search).title;
    const currentPageIndex = AlliedForcesApplicationSteps.findIndex(
      (elem) => elem.stepId === pageTitle
    );

    if (currentPageIndex === 0) {
      return pageTitle;
    }

    if (pageTitle === "military-basic") {
      if (props.application && props.application.userWillReLocate) {
        return AlliedForcesApplicationSteps[currentPageIndex - 1].stepId;
      }
      return AlliedForcesApplicationSteps[currentPageIndex - 2].stepId;
    }
    return AlliedForcesApplicationSteps[currentPageIndex - 1].stepId;
  };

  const displayErrorMessage = (message) => {
    removeErrorMessage();
    const dateInput = document.querySelector('input[type="date"]');
    const errorMessage = "Invalid date of birth.";
    const errorElement = document.createElement("span");
    errorElement.textContent = errorMessage;
    errorElement.style.fontSize = "16px";
    errorElement.classList.add("text-danger");
    const parentElement = dateInput.parentNode;
    parentElement.parentNode.insertBefore(
      errorElement,
      parentElement.nextSibling
    );
  };

  const removeErrorMessage = () => {
    const errorElement = document.querySelector(".text-danger");
    if (errorElement) {
      errorElement.remove();
    }
  };

  const checkStepFilled = (pageTitle) => {
    let applicationMetadata = props.application.applicationMetadata;
    let selectedStep;
    let isfilled = true;

    try {
      const { stepId } = AlliedForcesApplicationSteps.find(
        (elem) => elem.stepId === pageTitle
      );
      applicationMetadata.find((input) => {
        input.steps.find((step) => {
          if (step.stepId === stepId) {
            selectedStep = step;
          }
        });
      });
      isfilled = selectedStep.filled;
      return isfilled;
    } catch (e) {
      return isfilled;
    }
  };

  const validateField = (input, value, selectedItems) => {
    const pageTitle = queryString.parse(props.history.location.search).title;

    let error = false;
    let helperText = "";
    if (pageTitle === "career-interested_industries") {
      if (
        (Array.isArray(value) && value.length === 0) ||
        (Array.isArray(selectedItems) && selectedItems.length === 0)
      ) {
        error = true;
        helperText = "This field is required";
      }
    } else {
      if (input.required && !value) {
        error = true;
        helperText = "This field is required";
      }
    }

    return { error, helperText };
  };

  const nextHandler = async () => {
    const pageTitle = queryString.parse(props.history.location.search).title;
    let is_valid = true;
    let data;
    if (
      props.inputData !== "" &&
      (props.currentInputData === null || props.currentInputData === undefined)
    ) {
      data = props.inputData;
    } else if (
      props.inputData === "" &&
      (props.currentInputData !== null && props.currentInputData !== undefined)
    ) {
      data = props.currentInputData;
    } else if (
      props.inputData !== "" &&
      (props.currentInputData !== null && props.currentInputData !== undefined)
    ) {
      data = props.currentInputData;
    } else {
      is_valid = false;
    }

    const workingData = Array.isArray(data) ? data.map((d) => ({ ...d })) : data;
    if (workingData && Object.keys(workingData).length > 0) {
      workingData.forEach((d) => {
        const { error, helperText } = validateField(
          d,
          d.value,
          d.selectedItems
        );
        d.error = error;
        d.helperText = helperText;
        if (error && is_valid) {
          is_valid = false;
        }
      });
    } else if (!checkStepFilled(pageTitle)) {
      is_valid = false;
    } else {
      if (pageTitle === "introduction-video") {
        is_valid = true;
      } else {
        is_valid = false;
      }
    }
    if (pageTitle === "personal_info-basic") {
      const dateInput = document.querySelector('input[type="date"]');
      const selectedDate = new Date(dateInput.value);
      const minDate = new Date("1950-01-01");
      const maxDate = new Date();
      if (selectedDate < minDate || selectedDate > maxDate) {
        displayErrorMessage();
        return false;
      } else {
        removeErrorMessage();
      }
    }
    if (pageTitle !== constants.ALLIED_FORCES_APPLICATION_PROCESS_LAST_PAGE) {
      if (workingData) {
        try {
          const maybePromise = props.saveAlliedForcesApplication(workingData, props.history);
          if (maybePromise && typeof maybePromise.then === "function") {
            await maybePromise;
          }
        } catch (e) {
          // ignore save errors here; continue
        }
      }
      const nextPage = getNextPage();
      // Force a full reload when leaving the intro page to avoid first-click init race
      if (pageTitle === "introduction-video") {
        window.location.href = `/application/allied-forces?title=${nextPage}`;
        return;
      }
      props.history.push(`/application/allied-forces?title=${nextPage}`);

      if (!is_valid) {
        props.history.push(`allied-forces?title=${getPreviousPage()}`);
        const appSectionTitle = document.querySelector(".appSectionTitle");

        // Add Error Message
        removeErrorMessage();
        const errorMessage =
          "Please fill all the required (non-optional) fields before proceeding.";
        const errorElement = document.createElement("div");
        errorElement.textContent = errorMessage;
        errorElement.style.fontSize = "16px";
        errorElement.style.textAlign = "center";
        errorElement.classList.add("text-danger");
        const parentElement = appSectionTitle.parentElement;
        parentElement.appendChild(errorElement);
      } else {
        removeErrorMessage();
      }
    } else {
      submitApplication();
    }
  };

  const previousHandler = () => {
    const pageTitle = queryString.parse(props.history.location.search).title;
    if (pageTitle !== constants.ALLIED_FORCES_APPLICATION_PROCESS_FIRST_PAGE) {
      props.currentInputData &&
        props.saveAlliedForcesApplication(props.currentInputData, props.history);
    }
    const navigateAndReload = (url) => {
      window.location.href = url;
    };

    navigateAndReload(`/application/allied-forces?title=${getPreviousPage()}`);
  };

  const saveAndExitHandler = async () => {
    const pageTitle = queryString.parse(props.history.location.search).title;
    if (pageTitle === "personal_info-basic") {
      const dateInput = document.querySelector('input[type="date"]');
      const selectedDate = new Date(dateInput.value);
      const minDate = new Date("1950-01-01");
      const maxDate = new Date();
      if (selectedDate < minDate || selectedDate > maxDate) {
        displayErrorMessage();
        return false;
      } else {
        removeErrorMessage();
      }
    }
    try {
      if (props.currentInputData) {
        await props.saveAlliedForcesApplication(props.currentInputData, props.history);
      }

      if (props.user.has_submitted_application) {
        props.history.push("/home");
      } else {
        props.logout();
        props.history.push("/account/login");
      }
    } catch (error) {
      console.error("Error saving application:", error);
      // Still allow navigation even if save fails
      if (props.user.has_submitted_application) {
        props.history.push("/home");
      } else {
        props.logout();
        props.history.push("/account/login");
      }
    } finally {
      props.closeAllDrawers();
    }
  };

  const finalizeAndSubmitAlliedForcesApplication = () => {
    props.finalizeAndSubmitAlliedForcesApplication(
      props.history,
      props.currentInputData
    );
    props.closeAllDrawers();
  };

  const submitApplication = async () => {
    // Save latest edits and wait for metadata to update before validating
    if (props.currentInputData) {
      try {
        const maybePromise = props.saveAlliedForcesApplication(props.currentInputData, props.history);
        if (maybePromise && typeof maybePromise.then === "function") {
          await maybePromise;
        }
      } catch (e) {
        // ignore, validation below will guard
      }
    }
    if (allFormsFilled(props.application.applicationMetadata)) {
      if (props.user.has_submitted_application) {
        props.saveAlliedForcesApplication(props.currentInputData, props.history);
        props.history.push("/home");
      } else {
        props.toggleModal({
          modal_mode: true,
          modal_usi: "applicationConfirmation",
        });
      }
    } else {
      const appSectionTitle = document.querySelector(".appSectionTitle");
      removeErrorMessage();
      const errorMessage =
        "Please fill all the required (non-optional) fields before proceeding.";
      const errorElement = document.createElement("div");
      errorElement.textContent = errorMessage;
      errorElement.style.fontSize = "16px";
      errorElement.style.textAlign = "center";
      errorElement.classList.add("text-danger");
      const parentElement = appSectionTitle.parentElement;
      parentElement.appendChild(errorElement);
      props.saveAlliedForcesApplication(props.currentInputData, props.history);
      props.toggleAlliedForcesUnfilled();
      props.openDrawerAndPreventTertiary();
    }
  };

  const pageTitle = queryString.parse(props.history.location.search).title;

  return (
    <>
      <UserFieldEditorFooter
        nextHandler={nextHandler}
        previousHandler={previousHandler}
        renderPreviousButton={
          queryString.parse(props.history.location.search).title !==
          constants.ALLIED_FORCES_APPLICATION_PROCESS_FIRST_PAGE
        }
        saveAndExitHandler={saveAndExitHandler}
        toRenderSaveAndExitButton={!props.user.has_submitted_application}
        nextText={
          pageTitle === constants.ALLIED_FORCES_APPLICATION_PROCESS_LAST_PAGE
            ? props.user.has_submitted_application
              ? "Finish Editing"
              : "Submit"
            : "Next"
        }
      />
      <ApplicationConfirmationModal
        submitHandler={finalizeAndSubmitAlliedForcesApplication}
      />
    </>
  );
};

// TODO: Migrate this component to utilize hook
function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

const mapStateToProps = (state, props) => {
  try {
    const { applicationMetadata, currentInputData } =
      state.alliedForcesApplication;

    const pageTitle = queryString.parse(props.history.location.search).title;
    const { stepId } = AlliedForcesApplicationSteps.find(
      (elem) => elem.stepId === pageTitle
    );

    let selectedStep;

    applicationMetadata.find((input) => {
      return input.steps.find((step) => {
        if (step.stepId === stepId) {
          selectedStep = step;
        }
        return step.stepId === stepId;
      });
    });

    return {
      ...props,
      currentInputData,
      application: state.alliedForcesApplication,
      selectedStep,
      applicationInitialized: state.alliedForcesApplication.initialized,
      willLocate:
        state.alliedForcesApplication.address &&
        state.alliedForcesApplication.userWillReLocate,
      user: state.user.user,
    };
  } catch (e) {
    if (
      e.toString() === "TypeError: Cannot read property 'stepId' of undefined"
    ) {
      props.history.push("/account/login");
    }
    throw e;
  }
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithDrawerConsumer(AlliedForcesApplicationFooter))
);
